export default __webpack_public_path__ + "static/media/tab1.94474cc0.svg";